"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationForm = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var main_1 = require("../../../reducers/slices/main");
var form_validation_1 = require("./form_validation");
var create_application_1 = require("../../../api/calls/jobs/create_application");
var get_user_details_1 = require("../../../api/calls/user/get_user_details");
var address_list_1 = require("../../../api/calls/user/address_list");
var jobApplicationEmailHelper_1 = require("../../../helpers/jobApplicationEmailHelper");
var joinAddressValues = function (address) {
    var result = [];
    address.forEach(function (i) { return i && result.push(i); });
    return result.join(", ");
};
var parseAddress = function (fullAddress) {
    var parts = fullAddress.split(",").map(function (part) { return part.trim(); });
    return {
        street: parts[0] || "",
        city: parts.length > 2 ? parts[parts.length - 2] : "",
        province: parts.length > 1 ? parts[parts.length - 1] : "",
    };
};
var ApplicationForm = function (props) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var id = props.id, title = props.title, applicant = props.applicant, employer = props.employer;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _a = (0, react_1.useReducer)(form_validation_1.formReducer, form_validation_1.initialState), formState = _a[0], formDispatch = _a[1];
    var _b = (0, react_1.useState)(false), formIsValid = _b[0], setFormIsValid = _b[1];
    var _c = (0, react_1.useState)(false), isLoading = _c[0], setIsLoading = _c[1];
    var _d = (0, react_1.useState)(true), isLoadingUserData = _d[0], setIsLoadingUserData = _d[1];
    (0, react_1.useEffect)(function () {
        var fetchUserData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var userDetailsResponse, addressesResponse, fieldsToUpdate, nameParts, primaryAddress, parsedAddress, error_1;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 3, 4, 5]);
                        return [4 /*yield*/, (0, get_user_details_1.get_user_details)()];
                    case 1:
                        userDetailsResponse = _d.sent();
                        return [4 /*yield*/, (0, address_list_1.address_list)({ user_id: (_a = user === null || user === void 0 ? void 0 : user.integration_id) !== null && _a !== void 0 ? _a : "" })];
                    case 2:
                        addressesResponse = _d.sent();
                        fieldsToUpdate = {};
                        if (applicant.name) {
                            nameParts = applicant.name.split(" ");
                            fieldsToUpdate.firstName = { value: nameParts[0] || "" };
                            fieldsToUpdate.lastName = { value: nameParts.slice(1).join(" ") || "" };
                        }
                        if (applicant.email) {
                            fieldsToUpdate.email = { value: applicant.email };
                        }
                        if (addressesResponse.success && ((_c = (_b = addressesResponse.content) === null || _b === void 0 ? void 0 : _b.addresses) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                            primaryAddress = addressesResponse.content.addresses[0];
                            parsedAddress = parseAddress(primaryAddress.full_address);
                            fieldsToUpdate.streetAddress = { value: parsedAddress.street };
                            fieldsToUpdate.city = { value: parsedAddress.city };
                            fieldsToUpdate.province = { value: parsedAddress.province };
                        }
                        if (Object.keys(fieldsToUpdate).length > 0) {
                            formDispatch({ type: "SET_MULTIPLE_FIELDS", fields: fieldsToUpdate });
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _d.sent();
                        console.error("Error fetching user data:", error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        setIsLoadingUserData(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchUserData();
    }, [applicant.name, applicant.email, user === null || user === void 0 ? void 0 : user.integration_id]);
    var onChange = function (_a) {
        var _b;
        var field = _a.field, value = _a.value;
        formDispatch({ type: "SET_FIELD", field: field, value: value });
        var formData = __assign(__assign({}, formState), (_b = {}, _b[field] = __assign(__assign({}, formState[field]), { value: value, touched: true }), _b));
        validate(formData);
    };
    var isFormValid = function (form) {
        var result = Object.values(form).some(function (field) { return field.required && !field.value; });
        setFormIsValid(!result);
    };
    var validate = function (form) {
        var errors = {};
        isFormValid(form);
        if (!form.firstName.value && form.firstName.touched) {
            errors.firstName = "First Name is required";
        }
        if (!form.lastName.value && form.lastName.touched) {
            errors.lastName = "Last Name is required";
        }
        if (!form.email.value && form.email.touched) {
            errors.email = "Email is required";
        }
        if (!form.cvUpload.value && form.cvUpload.touched) {
            errors.cvUpload = "CV Upload is required";
        }
        formDispatch({ type: "SET_ERROR", errors: errors });
    };
    var onSubmit = function () {
        setIsLoading(true);
        var requestPayload = {
            job_id: id,
            first_name: formState.firstName.value,
            last_name: formState.lastName.value,
            email: formState.email.value,
            address: joinAddressValues([formState.streetAddress.value, formState.city.value, formState.province.value]),
            linkedin_url: formState.linkedInUrl.value,
            resume: formState.cvUpload.value,
            summary: formState.about.value,
        };
        (0, create_application_1.create_application)(requestPayload)
            .then(function (response) {
            setIsLoading(false);
            if (response.error === false) {
                // Send notification emails to applicant and employer
                (0, jobApplicationEmailHelper_1.sendJobApplicationEmails)({
                    applicant: applicant,
                    employer: employer,
                    jobDetails: { title: title, id: id },
                    dispatch: dispatch,
                });
                dispatch((0, main_1.setMessageModal)({
                    title: "Application Submitted",
                    messages: ["Your application has been submitted successfully."],
                }));
                // Close the form.
                dispatch((0, main_1.setContentModal)(null));
            }
            else {
                dispatch((0, main_1.setMessageModal)({
                    title: "Submission Error",
                    messages: ["There was an error submitting your application. Please try again later."],
                }));
            }
        })
            .catch(function (error) {
            setIsLoading(false);
            dispatch((0, main_1.setMessageModal)({
                title: "Submission Error",
                messages: ["There was an error submitting your application. Please try again later."],
            }));
        });
    };
    return (react_1.default.createElement("div", { className: "flex flex-col w-full gap-5" },
        react_1.default.createElement("div", { className: "flex flex-col md:flex-row gap-3" },
            react_1.default.createElement("div", { className: "flex flex-col gap-1 w-full md:w-1/2" },
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { required: formState.firstName.required, label: "First Name", size: "small", labelColor: "text-gray-500", errorText: formState.errors.firstName, value: formState.firstName.value, onChange: function (value) { return onChange({ field: "firstName", value: value }); } })),
            react_1.default.createElement("div", { className: "flex flex-col gap-1 w-full md:w-1/2" },
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { required: formState.lastName.required, label: "Last Name", size: "small", labelColor: "text-gray-500", errorText: formState.errors.lastName, value: formState.lastName.value, onChange: function (value) { return onChange({ field: "lastName", value: value }); } }))),
        react_1.default.createElement("div", { className: "flex flex-col gap-1" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { required: formState.email.required, label: "Email", size: "small", labelColor: "text-gray-500", errorText: formState.errors.email, value: formState.email.value, onChange: function (value) { return onChange({ field: "email", value: value }); } })),
        react_1.default.createElement("div", { className: "flex flex-col gap-1" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { required: formState.streetAddress.required, label: "Street Address", size: "small", labelColor: "text-gray-500", errorText: formState.errors.streetAddress, value: formState.streetAddress.value, onChange: function (value) { return onChange({ field: "streetAddress", value: value }); } })),
        react_1.default.createElement("div", { className: "flex flex-col md:flex-row gap-3" },
            react_1.default.createElement("div", { className: "flex flex-col gap-1 w-full md:w-1/2" },
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { required: formState.city.required, label: "City", size: "small", labelColor: "text-gray-500", errorText: formState.errors.city, value: formState.city.value, onChange: function (value) { return onChange({ field: "city", value: value }); } })),
            react_1.default.createElement("div", { className: "flex flex-col gap-1 w-full md:w-1/2" },
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { required: formState.province.required, label: "Province", size: "small", labelColor: "text-gray-500", errorText: formState.errors.province, value: formState.province.value, onChange: function (value) { return onChange({ field: "province", value: value }); } }))),
        react_1.default.createElement("div", { className: "flex flex-col gap-1" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { required: formState.linkedInUrl.required, label: "LinkedIn URL", size: "small", labelColor: "text-gray-500", errorText: formState.errors.linkedInUrl, value: formState.linkedInUrl.value, onChange: function (value) { return onChange({ field: "linkedInUrl", value: value }); } })),
        react_1.default.createElement("div", { className: "flex flex-col gap-1" },
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "CV Upload", size: "medium", textColor: "text-gray-500" }),
            react_1.default.createElement(doshx_controls_web_1.FileInputBoxControl, { onChange: function (f) { return onChange({ field: "cvUpload", value: f }); }, errorText: formState.errors.cvUpload, previewFile: true, required: formState.cvUpload.required, supportedFileTypes: [".pdf"], onClear: function () { return onChange({ field: "cvUpload", value: null }); } })),
        react_1.default.createElement("div", { className: "flex flex-col gap-1" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { required: formState.about.required, label: "Tell us about yourself", size: "small", labelColor: "text-gray-500", errorText: formState.errors.about, lines: 4, value: formState.about.value, onChange: function (value) { return onChange({ field: "about", value: value }); } })),
        react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Submit Application", backgroundColor: "bg-primary", size: "small", loading: isLoading, enabled: formIsValid && !isLoading, onClick: function () { return onSubmit(); } })));
};
exports.ApplicationForm = ApplicationForm;
